import React from 'react';
import { Button } from '@material-ui/core';

export default function SaveButton({ handleSubmit, width = '175px', height = '42px' }) {
  return (
    <Button
      variant="contained"
      color="primary"
      style={{
        width,
        height,
        marginLeft: '20px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '17px',
        textAlign: 'center',
      }}
      onClick={handleSubmit}
    >
      Save
    </Button>
  );
}
